<div *ngIf="isOpen"
    class="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animation-fade-in  ">
    <div
        class="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden flex flex-col animation-slide-up relative border border-transparent dark:border-slate-800">

        <!-- Header -->
        <div
            class="px-6 py-4 border-b border-slate-100 dark:border-slate-800 flex justify-between items-center bg-white dark:bg-slate-900">
            <h3 class="text-lg font-bold text-slate-800 dark:text-white tracking-tight flex items-center gap-2">
                <span class="material-icons text-green-500 dark:text-green-400">check_circle</span>
                สถานะตู้ชาร์จ
            </h3>
            <button (click)="closeModal()"
                class="w-8 h-8 rounded-full flex items-center justify-center hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-400 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 transition-all">
                <span class="material-icons">close</span>
            </button>
        </div>

        <!-- Body -->
        <div class="p-6 space-y-4">
            <div
                class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700 space-y-3">
                <div class="flex justify-between items-center">
                    <span class="text-slate-500 dark:text-slate-400 text-sm">ทะเบียนรถ:</span>
                    <span class="font-bold text-slate-800 dark:text-slate-200 text-lg">{{ data?.license || '-' }}</span>
                </div>
                <div class="w-full h-[1px] bg-slate-200 dark:bg-slate-700/50"></div>
                <div class="flex justify-between items-center">
                    <span class="text-slate-500 dark:text-slate-400 text-sm">พลังงาน:</span>
                    <span class="font-bold text-slate-800 dark:text-slate-200">{{ data?.chargingKwh || 0 }} kWh</span>
                </div>
                <div class="flex justify-between items-center">
                    <span class="text-slate-500 dark:text-slate-400 text-sm">ค่าบริการ:</span>
                    <span class="font-bold text-slate-800 dark:text-slate-200">{{ data?.chargingFee | number:'1.2-2' }}
                        บาท</span>
                </div>
                <div class="flex justify-between items-center">
                    <span class="text-slate-500 dark:text-slate-400 text-sm">เวลาชาร์จ:</span>
                    <span class="font-bold text-slate-800 dark:text-slate-200">{{ data?.second || 0 }} วินาที</span>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <div
            class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/80 flex justify-center">
            <button (click)="closeModal()"
                class="cursor-pointer px-8 py-2.5 rounded-xl bg-yellow-500 dark:bg-yellow-600 text-white font-bold hover:bg-yellow-600 dark:hover:bg-yellow-700 shadow-lg shadow-yellow-100 dark:shadow-none active:scale-95 transition-all">
                ตกลง
            </button>
        </div>

    </div>
</div>